/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductBrandResponseDto
 */
export interface ProductBrandResponseDto {
    /**
     * Brand ID
     * @type {number}
     * @memberof ProductBrandResponseDto
     */
    id: number;
    /**
     * Brand name/code
     * @type {string}
     * @memberof ProductBrandResponseDto
     */
    name: string;
    /**
     * Brand image URL
     * @type {string}
     * @memberof ProductBrandResponseDto
     */
    imageUrl: string | null;
}

/**
 * Check if a given object implements the ProductBrandResponseDto interface.
 */
export function instanceOfProductBrandResponseDto(value: object): value is ProductBrandResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('imageUrl' in value) || value['imageUrl'] === undefined) return false;
    return true;
}

export function ProductBrandResponseDtoFromJSON(json: any): ProductBrandResponseDto {
    return ProductBrandResponseDtoFromJSONTyped(json, false);
}

export function ProductBrandResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductBrandResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'imageUrl': json['imageUrl'],
    };
}

export function ProductBrandResponseDtoToJSON(value?: ProductBrandResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'imageUrl': value['imageUrl'],
    };
}

